<section
  class="visible relative m-4 rounded-none rounded-b-none bg-transparent shadow-none max-[767px]:relative max-[767px]:m-0 max-[767px]:flex max-[767px]:flex-wrap max-[767px]:justify-between max-[767px]:rounded-none max-[767px]:p-0 max-[767px]:shadow-none"
>
  @if (isOrderAvailable) {
    <div class="pr-0">
      <div class="sticky top-[60px] z-[2] bg-white">
        <app-detail-header
          [order]="order"
          [browserSize]="browserSize"
        ></app-detail-header>

        <div>
          @if (hasErrors) {
            <div
              class="mt-[15px] flex items-end justify-between border-b border-gray-500 pb-[15px] pl-[27px] text-sm max-[860px]:pl-5 max-[767px]:px-[10px] max-[767px]:pb-5 max-[767px]:pl-[39px]"
            >
              <p>Data was not loaded correctly. Try refreshing the page.</p>
            </div>
          } @else {
            <div
              class="mt-[15px] flex items-end justify-between border-b border-gray-500 pb-[15px] pl-[27px] text-sm max-[860px]:pl-5 max-[767px]:px-[10px] max-[767px]:pb-5 max-[767px]:pl-[39px]"
            >
              <div>
                <div class="sales-rep">
                  Sales Representative:
                  @if (order.Sales_Rep__c) {
                    <a
                      (click)="
                        viewContactInformation(
                          order.Sales_Rep__r,
                          'Sales Representative'
                        )
                      "
                      class="cursor-pointer underline"
                    >
                      {{ order.Sales_Rep__r?.Name }}
                    </a>
                  } @else {
                    <span>N/A</span>
                  }
                </div>
                <div>
                  Account Manager:
                  @if (order.Account_Manager__c) {
                    <a
                      (click)="
                        viewContactInformation(
                          order.Account_Manager__r,
                          'Account Manager'
                        )
                      "
                      class="cursor-pointer underline"
                    >
                      {{ order.Account_Manager__r?.Name }}
                    </a>
                  } @else {
                    <span>N/A</span>
                  }
                </div>
                <div>
                  Client Project Manager:
                  @if (order.Default_Task_Assignments__r) {
                    <a
                      (click)="
                        viewContactInformation(
                          order.Default_Task_Assignments__r.records[0].User__r,
                          'Client Project Manager'
                        )
                      "
                      class="cursor-pointer underline max-[376px]:flex"
                    >
                      {{
                        order.Default_Task_Assignments__r?.records[0]?.User__r
                          ?.Name
                      }}
                    </a>
                  } @else {
                    <span>N/A</span>
                  }
                </div>
              </div>
              @if (isPdf) {
                <button
                  class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border-none bg-transparent outline-none hover:bg-[rgba(24,193,223,0.5)]"
                  (click)="downloadFile()"
                >
                  <div
                    class="custom-icon pdf !h-[26px] !w-[26px] !pt-[26px] !leading-[26px]"
                  >
                    pdf icon
                  </div>
                </button>
              }
            </div>
          }
        </div>
      </div>
      <div>
        @if (isFileLoading) {
          <div class="loading-indicator">
            <mat-spinner [diameter]="50"></mat-spinner>
          </div>
        } @else if (
          formAPIData?.url && serviceOrderForm.ContentDocument && isFileLoaded
        ) {
          @if (isPdf && browserSize !== 'small') {
            <div class="h-full overflow-auto">
              <pdf-viewer
                class="h-full overflow-auto"
                [src]="fileUrl"
                [(page)]="currentFilePage"
                [show-all]="true"
                [show-borders]="false"
                [original-size]="false"
                [autoresize]="true"
                [render-text]="true"
                (error)="onFileError()"
                (after-load-complete)="afterFileLoadComplete($event)"
              ></pdf-viewer>
            </div>
          }
          <div class="mx-auto my-[50px] mb-5 flex justify-center">
            <div class="button-wrapper">
              <button
                class="primary-button w-[350px] max-[860px]:w-[300px]"
                (click)="downloadFile()"
              >
                <span class="text-base">Download Service Order Form</span>
              </button>
            </div>
          </div>
        } @else {
          <p class="px-[30px] py-5">
            <br />
            No Service Order Form has been posted to this deal yet.
          </p>
        }
      </div>
    </div>
  } @else if (!areOrdersLoading) {
    <div class="pr-5 max-[767px]:mt-[76px] max-[767px]:pr-0">
      <br />
      <p>The order you are requesting does not exist.</p>
    </div>
  }
  <app-footer class="hidden max-[767px]:block max-[767px]:w-full"></app-footer>
</section>
